module.exports = __webpack_public_path__ + "img/licence.73445e10.png";